import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { PolaznikUcioniceService } from './polaznik-ucionice.service';
import { Ucionica } from '../ucionica-popis/ucionica-popis';

import * as toastr from 'toastr';

declare var moment: any;
declare var $:any;

@Component({
  selector: 'app-polaznik-ucionice',
  templateUrl: './polaznik-ucionice.component.html',
  providers: [PolaznikUcioniceService]
})
export class PolaznikUcioniceComponent implements OnInit, AfterViewInit, OnDestroy {

  sveUcionice: Ucionica[] = [];

  datum: any = new Date();

  constructor(
    private _polaznikUcioniceService: PolaznikUcioniceService,
    public _router: Router
  ) { }

  ngOnInit() {
    this.dohvatiUcionice();
  }

  dohvatiUcionice(){
    this._polaznikUcioniceService.dohvatiDetalje({'idkorisnik': localStorage.getItem('userId'), 'datum': moment(this.datum).format('YYYY-MM-DD')}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['uc_datumod'] && res.data[i]['uc_datumdo']){
            this.sveUcionice.push({
              'id': res.data[i]['iducionica'],
              'wp_id': res.data[i]['uc_wpiducionica'],
              'naziv': res.data[i]['uc_naziv'],
              'vrstaEdukacije': res.data[i]['uc_vrstaEdukacije'],
              'trajanjeEdukacije': res.data[i]['uc_trajanjeEdukacije'],
              'grad': res.data[i]['uc_grad'],
              'datumOd': moment(res.data[i]['uc_datumod']).format('DD.MM.YYYY.'),
              'datumDo': moment(res.data[i]['uc_datumdo']).format('DD.MM.YYYY.'),
              'cijena': res.data[i]['uc_cijena'],
              'popustranaprijava': res.data[i]['uc_popustranaprijava'],
              'popustdvapolaznika': res.data[i]['uc_popustdvapolaznika'],
              'popusttripolaznika': res.data[i]['uc_popusttripolaznika'],
              'datumraneprijave': res.data[i]['datumraneprijaveprikaz'],
              'datumkasneprijave': res.data[i]['datumkasneprijaveprikaz'],
              'prikazivise': res.data[i]['uc_prikazivise'],
              'cjelovitisilabus': res.data[i]['uc_preuzimanjecjelovitogsilabusa'],
              'osnovneikomercijalneinformacije': res.data[i]['uc_osnovneikomercijalneinformacije'],
              'infovideo': res.data[i]['uc_infovideo'],
              'promovideo': res.data[i]['uc_promovideo'],
              'brojpolaznika': res.data[i]['brojpolaznika'],
              'statusucionice': res.data[i]['statuucionice'],
              'polozio': res.data[i]['ku_polozio'],
              'prikazweb': ''
            });
          } else {
            this.sveUcionice.push({
              'id': res.data[i]['iducionica'],
              'wp_id': res.data[i]['uc_wpiducionica'],
              'naziv': res.data[i]['uc_naziv'],
              'vrstaEdukacije': res.data[i]['uc_vrstaEdukacije'],
              'trajanjeEdukacije': res.data[i]['uc_trajanjeEdukacije'],
              'grad': res.data[i]['uc_grad'],
              'datumOd': null,
              'datumDo': null,
              'cijena': res.data[i]['uc_cijena'],
              'popustranaprijava': res.data[i]['uc_popustranaprijava'],
              'popustdvapolaznika': res.data[i]['uc_popustdvapolaznika'],
              'popusttripolaznika': res.data[i]['uc_popusttripolaznika'],
              'datumraneprijave': res.data[i]['datumraneprijaveprikaz'],
              'datumkasneprijave': res.data[i]['datumkasneprijaveprikaz'],
              'prikazivise': res.data[i]['uc_prikazivise'],
              'cjelovitisilabus': res.data[i]['uc_preuzimanjecjelovitogsilabusa'],
              'osnovneikomercijalneinformacije': res.data[i]['uc_osnovneikomercijalneinformacije'],
              'infovideo': res.data[i]['uc_infovideo'],
              'promovideo': res.data[i]['uc_promovideo'],
              'brojpolaznika': res.data[i]['brojpolaznika'],
              'statusucionice':  res.data[i]['statuucionice'],
              'polozio': res.data[i]['ku_polozio'],
              'prikazweb': ''
            });
          }
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  logoutFromClass(){
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/login']);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    $('body').removeClass('empty-layout');
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/polaznik-ucionice/polaznik-ucionice.component.ts